/**
 * Returns `true` if `x` is greater than or equal to `y`.
 *
 * @param {number|string} x
 * @param {number|string} y
 * @returns {boolean}
 */
export function gte(x, y) {
  return Number(x) >= Number(y);
}
